import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute, ParamMap, Params, NavigationStart, NavigationEnd } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { HeaderMenuComponent } from '../../../components/header-menu/header-menu.component';


@Component({
  selector: 'app-internal-registration-establishment',
  templateUrl: './internal-registration-establishment.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class InternalRegistrationEstablishmentComponent extends PageBase implements OnInit {
  public isInternet = false;
  public establishment = {
    modalities: [],
    name: '',
    categoryId: '',
    categorySelected: [],
    attendanceLocations: null,
    urls: {
      url_facebook_page : null,
      url_website : null,
      url_ios : null,
      url_android : null,
      url_win : null
    },
    cpf: null,
    cnpj: null
  };
  public categories = [];

  private stateList = [];
  private selectedStates = [];

  public isLoading;

  constructor(private translate: TranslateService,
    private toaster: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService) {

    super();

    let languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.getCategories();

    const establishmentAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'establishment' && establishmentAccount) {
      this.getEstablishment(establishmentAccount['id']);
    } else {
      this.toaster.error('Aviso!', 'Conta de negócio inválida', false, 4000);
      this.router.navigate(['/home']);
    }

    this.stateList = [
      {
        name: 'Acre',
        value: 'ac'
      },
      {
        name: 'Alagoas',
        value: 'al'
      },
      {
        name: 'Amapá',
        value: 'ap'
      },
      {
        name: 'Amazonas',
        value: 'am'
      },
      {
        name: 'Bahia',
        value: 'ba'
      },
      {
        name: 'Ceará',
        value: 'ce'
      },
      {
        name: 'Distrito Federal',
        value: 'df'
      },
      {
        name: 'Espírito Santo',
        value: 'es'
      },
      {
        name: 'Goiás',
        value: 'go'
      },
      {
        name: 'Maranhão',
        value: 'ma'
      },
      {
        name: 'Mato Grosso',
        value: 'mt'
      },
      {
        name: 'Mato Grosso do Sul',
        value: 'ms'
      },
      {
        name: 'Minas Gerais',
        value: 'mg'
      },
      {
        name: 'Pará',
        value: 'pa'
      },
      {
        name: 'Paraíba',
        value: 'pb'
      },
      {
        name: 'Paraná',
        value: 'pr'
      },
      {
        name: 'Pernambuco',
        value: 'pe'
      },
      {
        name: 'Piauí',
        value: 'pi'
      },
      {
        name: 'Rio de Janeiro',
        value: 'rj'
      },
      {
        name: 'Rio Grande do Norte',
        value: 'rn'
      },
      {
        name: 'Rio Grande do Sul',
        value: 'rs'
      },
      {
        name: 'Rondônia',
        value: 'ro'
      },
      {
        name: 'Roraima',
        value: 'rr'
      },
      {
        name: 'Santa Catarina',
        value: 'sc'
      },
      {
        name: 'São Paulo',
        value: 'sp'
      },
      {
        name: 'Sergipe',
        value: 'se'
      },
      {
        name: 'Tocantins',
        value: 'to'
      }
    ];
  }

  private getEstablishment(establishmentId): void {
    this.request.get({path: 'establishments', pathParam: `/${establishmentId}`}).then((establishment) => {
      this.establishment = establishment;
      this.setCategory();
      this.selectedStates = this.establishment['attendanceLocations'] || [];

      if (this.establishment.urls) {
        this.establishment.urls['url_website'] = this.establishment.urls && this.establishment.urls.url_website ? this.establishment.urls.url_website : null;
        this.establishment.urls['url_facebook_page'] = this.establishment.urls && this.establishment.urls.url_facebook_page ? this.establishment.urls.url_facebook_page : null;
        this.establishment.urls['url_ios'] = this.establishment.urls && this.establishment.urls.url_ios ? this.establishment.urls.url_ios : null;
        this.establishment.urls['url_android'] = this.establishment.urls && this.establishment.urls.url_android ? this.establishment.urls.url_android : null;
        this.establishment.urls['url_win'] = this.establishment.urls && this.establishment.urls.url_win ? this.establishment.urls.url_win : null;
      } else {
        this.establishment.urls = {
          url_facebook_page : null,
          url_website : null,
          url_ios : null,
          url_android : null,
          url_win : null
        };
      }

    });
  }

  public checkModality(modality: number): boolean {
    return this.establishment && this.establishment['modalities'].indexOf(modality) > -1;
  }

  // Get categories

  public changeCategory(value: Object): void {
    const category = value[0] || null;
    const categorySelected = this.categories.filter((categoryItem) => categoryItem.id === category.id);

    this.establishment['categorySelected'] = categorySelected;
    this.establishment['categoryId'] = categorySelected[0]['id'].toString();
  }

  private getCategories(): void {
    this.request.get({ path: 'categories'}).then((res) => {
      let categories = res || [];
      categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          text: category.name,
          title_offer_sample: category.title_offer_sample,
          text_offer_sample: category.text_offer_sample,
          tags: category._tags
        });
      });
      if (this.establishment && this.establishment['categoryId']) {
        this.setCategory();
      }
    });
  }

  private setCategory() {
    this.categories.forEach((item) => {
      if (item.id.toString() === this.establishment['categoryId'].toString()) {
        this.establishment['categorySelected'] = [item];
      }
    });
  }


  public toggleKind(modality): void {
    let index: number = this.establishment['modalities'].indexOf(modality);
    if (index > -1) {
      this.establishment['modalities'].splice(index, 1);
    } else {
      this.establishment['modalities'].push(modality);
    }
  }

  public checkState(state): boolean {
    return this.selectedStates.indexOf(state['value']) > -1;
  }

  public toggleAttendanceLocation(state): void {
    if (this.checkState(state)) {
      let index: number = this.selectedStates.indexOf(state['value']);
      this.selectedStates.splice(index, 1);
    } else {
      this.selectedStates.push(state['value']);
    }
    this.establishment['attendanceLocations'] = this.selectedStates;
  }

  public toggleAll(): void {
    this.establishment['attendanceLocations'] = 'allSelected';
    if (this.selectedStates.length === 27) {
      this.selectedStates = [];
    } else {
      this.selectedStates = [];
      for (const state of this.stateList) {
        this.selectedStates.push(state['value']);
      }
    }
    this.establishment['attendanceLocations'] = this.selectedStates;
  }

  public updateEstablishment(): void {
    if (!this.validateModel()) {
      return;
    }

    const establishmentData = Object.assign({}, this.establishment);
    delete establishmentData['categorySelected'];

    this.isLoading = true;
    this.request.put('establishments', establishmentData).then((establishment) => {
      this.isLoading = false;
      if (establishment) {
        this.toaster.info('Sucesso', 'Dados de negócio salvo com sucesso.', true, 2000);
        this.userService.requestAccountConfig();
      }
    });
  }

  private validateModel(): boolean {
    if (!this.establishment['name']) {
      this.toaster.info('Atenção', 'Preencha o nome do negócio.', false, 2000);
      return false;
    }

    if (!this.establishment['categoryId']) {
      this.toaster.info('Atenção', 'Preencha a categoria do negócio.', false, 2000);
      return false;
    }

    if (this.establishment['modalities'].length === 0) {
      this.toaster.info('Atenção', 'Preencha a modalidade do negócio.', false, 2000);
      return false;
    }

    return true;
  }
}
